module.exports = __webpack_public_path__ + "img/32grzl.bcb7a7d4.svg";